import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClick: () => void;
}
export function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-gray-200 rounded-lg mb-3 overflow-hidden bg-white shadow-sm" data-id="element-1">
      <button className="w-full flex justify-between items-center p-4 text-left font-bold text-gray-800 hover:bg-gray-50 transition-colors" onClick={onClick} data-id="element-2">
        <span className="pr-4" data-id="element-3">{title}</span>
        <ChevronDown className={`w-5 h-5 text-emerald-600 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'transform rotate-180' : ''}`} data-id="element-4" />
      </button>
      <AnimatePresence initial={false} data-id="element-5">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-6">
            <div className="p-4 pt-0 text-gray-600 border-t border-gray-100 bg-gray-50" data-id="element-7">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Accordion({
  items
}: {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto" data-id="element-8">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-9">
          {item.content}
        </AccordionItem>)}
    </div>;
}